import React from 'react'

export default class IconsMainNavForms extends React.Component {
    render() {
        let className = 'icons-icon'

        return (
            <svg
                xmlns='http://www.w3.org/2000/svg'
                width='16'
                height='16'
                viewBox='0 0 16 16'
                fill='none'
                className={className}
                style={this.props.style}
            >
                <path
                    d='M8 13.3333H7.33333C6.97971 13.3333 6.64057 13.1929 6.39052 12.9428C6.14048 12.6928 6 12.3536 6 12C6 12.3536 5.85952 12.6928 5.60948 12.9428C5.35943 13.1929 5.02029 13.3333 4.66667 13.3333H4'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M8.66666 5.33331H13.3333C13.6869 5.33331 14.0261 5.47379 14.2761 5.72384C14.5262 5.97389 14.6667 6.31302 14.6667 6.66665V9.33331C14.6667 9.68693 14.5262 10.0261 14.2761 10.2761C14.0261 10.5262 13.6869 10.6666 13.3333 10.6666H8.66666'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M3.33334 10.6666H2.66668C2.31305 10.6666 1.97392 10.5262 1.72387 10.2761C1.47382 10.0261 1.33334 9.68693 1.33334 9.33331V6.66665C1.33334 6.31302 1.47382 5.97389 1.72387 5.72384C1.97392 5.47379 2.31305 5.33331 2.66668 5.33331H3.33334'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path
                    d='M4 2.66669H4.66667C5.02029 2.66669 5.35943 2.80716 5.60948 3.05721C5.85952 3.30726 6 3.6464 6 4.00002C6 3.6464 6.14048 3.30726 6.39052 3.05721C6.64057 2.80716 6.97971 2.66669 7.33333 2.66669H8'
                    stroke='#646464'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
                <path d='M6 4V12' stroke='#646464' strokeWidth='1.5' strokeLinecap='round' strokeLinejoin='round' />
            </svg>
        )
    }
}
